import React from "react";
import { ProductSelectionGridSSR } from "tsi-common-react/src/apps/product-compare/ProductSelectionGridSSR/index";

import { templates } from "@reactivated";

export const Template = (
    props: templates.ProductSelectionGridBlockTemplate,
): React.JSX.Element => <ProductSelectionGridSSR {...props} showStartingAt />;
